<template>
 
  <div id="Vue"  >
 	<el-dialog
	  title="使用说明"
	  :visible.sync="dialogVisible1"
	  width="66%" >
	      <span style='font-weight:bold'>一 数据来源：</span>
		  </br>
		  <span>该数据为国外数据服务商根据各大社媒平台包括 linkedIn, facebook, twitter, github 等6亿人员的信息整理搜集而来，并且定期更新维护，通过这些数据能够精确反映一个人员的画像 . </span>
		 
		  <span>根据用户习惯, 欧美客户可以通过facebook或者邮箱与公司决策人互动，中东，东南亚等客户可以通过移动电话加whatsapp 沟通,通过这些方式能够更快与目标客户达成联系。 </span>
		  
	      </br>
	      <span style='font-weight:bold'> 二 操作方法说明：</span>
		  </br>
		  <span>1, 设置公司名称 </span>
		  </br>
		  <span>2, 点击搜索后将会搜索该公司决策人的信息 </span>
		  </br>
		  <span>3, 选择需要的人员点击解锁，匹配到的数据，请到 领英数据 -> 我关注的人员 中可以查看.   </span>
		  
		  </br>
	      <span style='font-weight:bold'>三 费用说明：</span>
		  </br>
		  <span>1, 每查询并匹配到一条数据扣费 5 元，匹配不到数据不扣费 </span>
		  
		  
		  		  
		  <span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible1 = false">取 消</el-button> 
		  </span>
	</el-dialog>   
  <el-row >
  <el-col :span="22" :offset="1"> 
   
  <el-row  style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
  <el-form ref="form"  :inline="true" :model="form" label-width="80px" class="demo-form-inline">
  <el-form-item  >
	  <el-input placeholder="请输入公司名称" v-model="company_name" style="width:600px">
		<template slot="prepend">公司名称：</template> 
	  </el-input>
  </el-form-item> 
  <el-form-item> 
    <el-radio-group v-model="match" v-loading="loading" >
      <el-radio label="精准匹配"></el-radio>
      <el-radio label="模糊匹配"></el-radio> 
    </el-radio-group>
  </el-form-item> 
  <el-form-item>
    <el-button type="primary" :loading="loading" icon="el-icon-search" @click="handleChange"  >搜索</el-button>
  </el-form-item>  
  
  <el-form-item style="float:right">
    <el-button size="mini" icon="el-icon-warning-outline"   @click="dialogVisible1 = true" plain >使用说明</el-button>
  </el-form-item> 
  </el-form>
 

  </el-row>
 
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
 
  
  <el-table id="dataList" v-loading="loading"
    :data="tableData" 
	border 
    style="width: 100%"
	
     >

    <el-table-column
       
      prop="htmlTitle"
      label="标题(姓名及职位)"
      min-width="20%">
	  <template slot-scope="scope">
                            <div v-html="scope.row.htmlTitle"></div>
                        </template> 
    </el-table-column>

    <el-table-column
      prop="link"
      label="领英链接"
      min-width="15%">
    </el-table-column>
    <el-table-column
      prop="htmlSnippet"
      label="描述"
      min-width="20%">
	  <template slot-scope="scope">
                            <div v-html="scope.row.htmlSnippet"></div>
                        </template> 
    </el-table-column>
    <el-table-column 
      label="操作" 
	  width="260"
      min-width="10%">
	  	 <template slot-scope="scope">
				<el-button  type="success" size="mini"   @click="handleDetail(scope.$index, scope.row)">解锁联系人信息</el-button>
				<el-tooltip class="item" effect="light" content="需要安装小火箭 " placement="top-start"> 
				<el-button   size="mini"   @click="handleOpen(scope.$index, scope.row)">打开领英</el-button> 
                </el-tooltip>
		 </template>
    </el-table-column>
  </el-table>
  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
 
  <el-pagination @current-change="handlePageChange" :current-page="page" :page-size="10" layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination>
 				
  </div>
  </el-row>  
  </el-col>
  </el-row>
</div>
</template>
<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>

<script>
  
export default {
 
        data () {
            return {
	    	component_name: '',
			match: '模糊匹配',
		    userInfo: {},
			loading: false,
			login_state : false,
			id: 0,
			user_id: 0,
			page: 1,
			size:10,
		    total: 0,
			buttonQuery: 1,
			dialogVisible1: false,
			status:true,
			region: '',
			company_name:'',
			company_type:'',
			company_email:'',
			company_address: '',
			tableHeight: '600px',
			dialogVisible: false,
			form:{  
				   
				 },
			tableData:[],
			}  
        },
        methods: {
		    handleDetail(index, row){
				if (this.user_id == 0) {
				    this.$message({
							message: '登录后进行查询 ! ',
							type: 'success'
							});
				    return;
				}
                //搜索人员过程
				let that = this;   
				that.loading = true;
				let ct =  row.link.replace("https://www.", "") ;
				console.log('user_id              : ' + that.user_id );
				$.ajax({
					  type: "POST",
					  data:  {user_id: that.user_id,  
							  size: 1,  
							  liUrl : ct,  
							   
							  },
					  url: "https://www.myferp.com/admin/linkedIn/getPeople",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: 'error',
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						  console.log(JSON.stringify(data)); 
						  
						  if (data.errno == 500){
						      that.$message({
								  message: '余额不足，请至会员服务充值! ',
								  type: 'error'
								  });
								  that.loading = false;	
								  that.status = true; 
								  that.people_data =  {};
								  that.people_education = [];
								  that.people_experience = [];
								  that.people_social = [];
								  that.people_location = [];
						      return;
						  }
						  var info = data.data.info;
						  if (info.hasOwnProperty("status")){
						  
							  if (info.status != 200){
								  that.$message({
								  message: '未查询到相关数据! ',
								  type: 'error'
								  });
								  that.loading = false;	
								  that.status = true; 
								  that.people_data =  {};
								  that.people_education = [];
								  that.people_experience = [];
								  that.people_social = [];
								  that.people_location = [];
								  
								  return;
								 }
							 
							  that.people_data_array = data.data.info.data ; 
							  if (that.people_data_array.length == 1){
							  	  that.$message({
								  message: '成功查询到数据，请点击我的领英数据查看! ',
								  type: 'success'
								  });
								  that.people_data = that.people_data_array[0];
								  that.people_education = that.people_data_array[0].education;
								  that.people_experience = that.people_data_array[0].experience;
								  that.people_social = that.people_data_array[0].profiles;
								  that.people_location = that.people_data_array[0].street_addresses;
								  
								  }
						   }
						  if (info.hasOwnProperty("statusCode")){
							  if (info.statusCode >= 400){
								  that.$message({
								  message: 'code: ' + info.statusCode + ' 未查询到相关数据! '  ,
								  type: 'error'
								  });
								  that.loading = false;	
								  that.status = true; 
								  that.people_data =  {};
								  that.people_education = [];
								  that.people_experience = [];
								  that.people_social = [];
								  that.people_location = [];						  
								  return;
								 }
						      }
						  that.loading = false;	
                          that.status = false;						  
						  }
					  });
			   
			},
		    handleOpen(index, row){
              window.open(row.link); 
			   
			},
			handleChange(){
			    console.log('compnay name: ' + this.company_name);
				if (this.company_name == '' || this.company_name == undefined || this.company_name == "undefined"){
				    this.$message({
							message: '关键词不能为空 ! ',
							type: 'warning'
							});
				    return;
				}			    
			
			    this.page = 1; 
				this.getInfo();
			},

			
		    handleSelect(key, keyPath) {
	           if (key == 1)
			      this.back();
				  
	           if (key == 2)
			      this.login();				  
			},
			handlePageChange(val) {
				this.page = val;
 
				this.getInfo()
			},		
		    onSubmit(){
			    console.log('compnay name: ' + this.company_name);
				if (this.company_name == '' || this.company_name == undefined || this.company_name == "undefined"){
				    this.$message({
							message: '关键词不能为空 ! ',
							type: 'warning'
							});
				    return;
				}			    
			
			    this.page = 1; 
				this.getInfo();
				},
			getInfo( ){ 
			    let that = this;
				that.loading = true;
				console.log('page: ' + that.page);
				that.tableHeight = "800px"; 
				  $.ajax({
					  type: "POST",
					  data:  {user_id: that.user_id, 
					          page: parseInt(that.page) , 
							  size: 10, 
							  company_name: that.company_name, 
							  match: that.match,
							  },
					  url: "https://www.myferp.com/admin/linkedIn/google",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: data,
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						  console.log(JSON.stringify(data));
						  
						  that.tableData = data.data.items ;  
						  that.total = parseInt(data.data.searchInformation.totalResults); 
						  that.loading = false;	 				  
						  }
					  });
		    },
			
			login()
			{
			  this.$router.push({
					path: '/login',
					params: {
					  sometext: ''
					}
				  }); 
			},

			back()
			{ 
			  this.$router.push({
					path: '/home/index',
					params: {
					  sometext: ''
					}
				  });  
			},
 

		},
        mounted() {
			let userInfo = localStorage.getItem('userInfo'); //判断登录状态
			console.log( 'user:' + typeof userInfo);  

			let info = {};
			let user_id = 0;
			if (userInfo != null && userInfo != '' && typeof userInfo != undefined){
				info = JSON.parse(userInfo);
				user_id = info.id; 
				this.user_id = user_id;					
				}  		
            console.log('name:' + this.$route.query.companyName);	
            this.page = 1;
            this.size = 10;			
		    this.company_name =  this.$route.query.companyName; 
			console.log('company :' + this.company_name);
            if (this.company_name != '' && this.company_name != undefined  )			
		  	   this.getInfo();
			 
           },		   
		
    } ;

 
	 
</script>
 


// WEBPACK FOOTER //
// src/components/customs/customsContact.vue